import request from '@/utils/request'

//仓库管理


//查询仓库列表
export function getCkList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/list",
        data: data
    })
}
//获取保管员列表
export function getCkgly() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/getCkgly"
    })
}
//保存仓库信息
export function addOrUpdSave(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/addOrUpdSave",
        data: data
    })
}
//获取仓库信息详情
export function detail(data) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/getCkxx/" + data
    })
}
//停用仓库
export function stopCkxx(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/changeStatusCkxx",
        data: data
    })
}
//获取行政区划级联树
export function getXzqTree() {
    return request({
        method: 'get',
        url: "/organization/api/xzqh/tree"
    })
}
//获取行政区划级联树
export function getXzqTreeS(id) {
    return request({
        method: 'get',
        url: "/organization/api/xzqh/tree/" + id
    })
}

//获取租赁单位
export function getWldwList(data) {
    return request({
        method: 'post',
        url: '/yzdservice/enterprise/wldw/list',
        data:data
    })
}
//查看获取仓库信息详情
export function getQueryXx(id) {
    return request({
        method: 'get',
        url: '/yzdservice/enterprise/dwCk/detail/'+id
    })
}
